"use client";

import { c as _c } from "react/compiler-runtime";
import { Card, CardContent } from "@/components/ui/card";
import { Cigarette, FileText, PawPrint } from "lucide-react";
import { useTranslations } from "next-intl";
type Props = {
  petFriendly?: boolean;
  contract?: boolean;
  smokingAllowed?: boolean;
  isDemand?: boolean;
};
export function RealEstateDetailHouseRules(t0) {
  const $ = _c(23);
  const {
    petFriendly,
    contract,
    smokingAllowed,
    isDemand
  } = t0;
  const t = useTranslations("modules.realEstateDetail");
  let t1;
  if ($[0] !== petFriendly || $[1] !== t) {
    t1 = petFriendly && {
      id: "petFriendly",
      Icon: PawPrint,
      label: t("rulePetFriendly")
    };
    $[0] = petFriendly;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== contract || $[4] !== t) {
    t2 = contract && {
      id: "contract",
      Icon: FileText,
      label: t("ruleContract")
    };
    $[3] = contract;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== smokingAllowed || $[7] !== t) {
    t3 = smokingAllowed && {
      id: "smokingAllowed",
      Icon: Cigarette,
      label: t("ruleSmoking")
    };
    $[6] = smokingAllowed;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = [t1, t2, t3].filter(Boolean);
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const rules = t4 as {
    id: string;
    Icon: typeof PawPrint;
    label: string;
  }[];
  if (rules.length === 0) {
    return null;
  }
  let t5;
  if ($[13] !== isDemand || $[14] !== t) {
    t5 = isDemand ? t("houseRulesDemandTitle") : t("houseRulesTitle");
    $[13] = isDemand;
    $[14] = t;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t5) {
    t6 = <h2 className="text-xl font-bold mb-4 text-foreground-heading">{t5}</h2>;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== rules) {
    t7 = <div className="flex flex-wrap gap-2">{rules.map(_temp)}</div>;
    $[18] = rules;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = <Card className="bg-card border-none shadow-sm" data-sentry-element="Card" data-sentry-component="RealEstateDetailHouseRules" data-sentry-source-file="RealEstateDetailHouseRules.tsx"><CardContent data-sentry-element="CardContent" data-sentry-source-file="RealEstateDetailHouseRules.tsx">{t6}{t7}</CardContent></Card>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}
function _temp(t0) {
  const {
    id,
    Icon,
    label
  } = t0;
  return <span key={id} className="inline-flex items-center gap-1.5 rounded-full border border-border bg-background px-3 py-1.5 text-sm text-foreground"><Icon className="h-4 w-4" />{label}</span>;
}